<div #elemet (click)="onClick()" class="item" style="background-image: url('{{image.url}}');" [ngStyle]="{'width': width+'vw', 'margin-left': margin+'vw'}"> </div>
